module.exports = __webpack_public_path__ + "media/images/flags/16/Albania-166e8ec3b3ae75391613a0c35ca55c1c.png";